/** Keep provider tickets in memory; navigation uses only safe application paths. */
export function navigateAdminSession(path: string) {
  window.location.assign(path);
}
